// @ts-nocheck
// @ts-nocheck
import LoginPageStyles from "./LoginPage.module.scss";
import OrbitLogo from "../../assets/images/OrbitLogo.png";
import OrionLogo from "../../assets/images/orion_logo.png";
import OrbitLogoNew from "../../assets/images/orbitLogoNew.svg";
import OrbitTextLogo from "../../assets/orbit_text_logo.svg";
import GoogleLogo from "../../assets/images/googleLogo.svg";
import NovaLogo from "../../assets/images/logo-nova-white-bg.png";
import { useGoogleLogin } from "@react-oauth/google";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "../../auth/auth";
import { ROUTES } from "../../common/constants";
import { getTokensFromGAuthCode } from "../../services/auth.service";
import { UserRolesKey } from "../../modules/Admin/constants";
import { getProjectMappings } from "../../services/common.service";
import SourcingHubSvg from "../../assets/images/sourcing_hub_icon.svg";
import VerizonSvg from "../../assets/images/VerizonLogo.svg";
const LoginPage = () => {
  const [projectName, setProjectName] = useState("");
  const navigate = useNavigate();
  const auth = Auth.getInstance();
  useEffect(() => {
    const fetchProjectName = async () => {
      try {
        const response = await getProjectMappings();
        if (
          response &&
          response.project_names &&
          response.project_names.length > 0
        ) {
          const projectName = response.project_names[0];
          localStorage.setItem("projectName", projectName);
          setProjectName(projectName);
          document.title = projectName.toUpperCase();
          const link = document.querySelector(
            "link[rel*='icon']"
          ) as HTMLLinkElement | null;
          if (link) {
            link.href = `${
              process.env.PUBLIC_URL
            }/${projectName.toLowerCase()}_logo.svg`;
          } else {
            const newLink = document.createElement("link");
            newLink.type = "image/x-icon";
            newLink.rel = "shortcut icon";
            newLink.href = `${
              process.env.PUBLIC_URL
            }/${projectName.toLowerCase()}_logo.svg`;
            document.getElementsByTagName("head")[0].appendChild(newLink);
          }
        }
      } catch (error) {
        console.error("Error fetching project name:", error);
      }
    };

    fetchProjectName();
  }, []);

  const handleClick = useGoogleLogin({
    scope: `https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/documents`,
    flow: "auth-code",
    onSuccess: async (tokenResponse) => {
      const redirectUri =
        projectName === "SourcingHub"
          ? process.env.REACT_APP_GOOGLE_AUTH_REDIRECT_URI_SOURCING_HUB
          : process.env.REACT_APP_GOOGLE_AUTH_REDIRECT_URI_ORION_DEV;
      const res = await getTokensFromGAuthCode({
        code: tokenResponse?.code,
        redirect_uri: process.env.REACT_APP_GOOGLE_AUTH_REDIRECT_URI,
      });
      auth.saveGoogleCodes({
        access_token: res?.access_token,
        refresh_token: res?.refresh_token,
        code: tokenResponse?.code,
      });

      const loginResponse = await auth.login({
        access_token: res?.access_token,
      });

      if (loginResponse.isAuthenticated) {
        navigate(ROUTES.dashboard);
      }
    },
    onError: (error) => {},
  });
  useEffect(() => {
    if (auth.getAccessToken() !== null) {
      navigate(ROUTES.dashboard);
    }
  }, [auth, navigate, projectName]);

  return (
    <div className={LoginPageStyles.loginWrapper}>
      <div className={LoginPageStyles.loginbox}>
        <div className={LoginPageStyles.content}>
          <div className={LoginPageStyles.logo}>
            <img
              src={require("../../assets/Orion Logo home.svg").default}
              alt="Orion GSA Logo"
              style={{ height: "56px", marginBottom: "8px" }}
            />
          </div>

          <div className={LoginPageStyles.tagline}>
            <h2
              className={
                projectName === "SourcingHub"
                  ? LoginPageStyles.sourcingHubGradient
                  : LoginPageStyles.vendorGradient
              }
            >
              {projectName === "SourcingHub" ? (
                <>
                  Super Charge Sourcing
                  <br />
                  Operations
                </>
              ) : (
                <>
                  Super Charge Vendor
                  <br />
                  Management Operations
                </>
              )}
            </h2>
            <p>Smarter, Faster, Seamless</p>
          </div>

          <div
            onClick={handleClick}
            className={
              `${LoginPageStyles.loginBtn} ` +
              (projectName === "SourcingHub"
                ? LoginPageStyles.sourcingHubBtn
                : LoginPageStyles.vendorBtn)
            }
          >
            {/* <img src={GoogleLogo} alt="" /> */}
            <span>Sign in with SSO</span>
          </div>
        </div>
      </div>
      <div className={LoginPageStyles.bottomBorder}></div>
    </div>
  );
};

export default LoginPage;
